import React from 'react';
const CopyRight = () => {
  return (
    <footer className='w-full border-t border-gray-300 py-4 text-center text-sm text-gray-500'>
      <p>
        © 2025 LeadGenPro. All Rights Reserved.{' '}
        <a
          href='/privacy-policy'
          className='text-blue-500 hover:underline'
        >
          Privacy
        </a>
      </p>
    </footer>
  );
};

export default CopyRight;
